import React from 'react'

//@ts-ignore
import styles from '../style.module.css'

export const Divider = () => {
  return <div className={styles['divider']} />
}
